// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__LNKq6","ButtonActive":"Button_ButtonActive__Sh9pw","fa-scroll":"Button_fa-scroll__HLXj8","notes":"Button_notes__4hbhH","notes_btn":"Button_notes_btn__DG1UG"};